import { isAdminSite, isRevIntelSite } from "./appConfig";

// The main app opened directly in a browser tab rather than inside the extension's
// injected iframe. The admin and revintel sites have always run top-level and keep
// their own extension handling, so they don't count.
const isStandalone = () =>
  window.self === window.top && !isAdminSite() && !isRevIntelSite();

let routerNavigate = null;

// Registered by CustomRoutes so code outside components (postToExtension) can route
// without a full page reload.
const setStandaloneNavigate = (navigate) => {
  routerNavigate = navigate;
};

const navigateStandalone = (path) => {
  const { pathname, search } = window.location;
  if (`${pathname}${search}` === path) {
    return;
  }
  if (routerNavigate) {
    routerNavigate(path);
    return;
  }
  window.location.assign(path);
};

export { isStandalone, setStandaloneNavigate, navigateStandalone };
